import { combineReducers } from "redux";
import creditPolicyReducer from "./credit-policy";
import documentPolicyReducer from "./document-policy";
import usersReducer from "./users-permission";

export default combineReducers({
    creditPolicy: creditPolicyReducer,
    documentPolicy: documentPolicyReducer,
    users: usersReducer
});